import React, { Fragment, useState } from 'react';
import {
    Button, Dialog, DialogTitle, DialogContent, makeStyles, Grid,
    Radio, RadioGroup, FormControlLabel, FormControl, Backdrop, CircularProgress, Divider
} from '@material-ui/core';
//Notificacion errores https://iamhosseindhv.com/notistack/demos#variants
import { useSnackbar } from 'notistack';
//componentes del sistema
import { palette, useStylesGlobal } from 'configurations/styles/theme';
import { useSelector } from 'react-redux';
import { getRUCEmpresa } from 'redux/actions/userActions';
import { httpReportes } from 'configurations/axios';
import Alert from 'widgets/alert';
import useForm from 'hooks/useFrom';
import validations from '../validations';
import { API_POST_SAVE_CLIENTS } from '../apis';
import { useStylesApp } from 'hooks/useStyles';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

const useStyles = makeStyles((theme) => ({
    formControl: {
        marginTop: theme.spacing(0),
        minWidth: 120,
    },
    radio: {
        display: '-webkit-box',
        marginTop: '0px'
    },
    radioLable: {
        color: palette.primary.main,
        display: 'flex'
    },
    radioButton: {
        marginTop: '0px',
        paddingTop: '0px'
    },
    divForm: {
        marginBottom: '1%',
    },
    divInput: {
        marginBottom: '1%',
        paddingRight: '1%',
        paddingLeft: '0.5%'
    },
    divButton: {
        paddingLeft: '3%',
        paddingRight: '3%'
    },
    backdrop: {
        zIndex: theme.zIndex.modal + 999,
        color: palette.primary.main,
    },
}));

const AddClientBtn = ({ updateView }) => {
    const classes = useStyles();
    const classesApp = useStylesApp();
    const classesGlobal = useStylesGlobal();
    const [openLoader, setOpenLoader] = useState(false);
    const [open, setOpen] = useState(false);
    const [pasaporteCheck, setPasaporteCheck] = useState("C");
    const userToken = useSelector(state => state.user.tk);
    const [msgError, setMsg] = useState({ show: false, msg: null, type: null });
    const { enqueueSnackbar } = useSnackbar();
    const [client, setClient] = useState({
        rucEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
        parteRelacionada: false,
    });

    const existError = () => {
        setOpenLoader(false);
    }

    const handleSave = async () => {
        setOpenLoader(true);
        console.log(client)
        await httpReportes.post(API_POST_SAVE_CLIENTS, client).then(
            response => {
                if (response.status === 200) {
                    enqueueSnackbar("Proveedor almacenado.", {
                        variant: 'success',
                        anchorOrigin: {
                            vertical: 'top',
                            horizontal: 'right',
                        },
                        autoHideDuration: 10000,
                    });
                    updateView();
                    setOpenLoader(false);
                    setOpen(false);
                }
            }
        ).catch(
            exception => {
                if (exception.response) {
                    if (exception.response.status === 400) {
                        setMsg({ show: true, msg: 'No se pudo almacenar el proveedor.' });
                    } else if (exception.response.status === 404) {
                        setMsg({ show: true, msg: 'No se encontró la empresa enviada para relacionarla con el proveedor.' });
                    } else if (exception.response.status === 409) {
                        setMsg({ show: true, msg: 'El proveedor ya existe.' });
                    } else {
                        setMsg({ show: true, msg: 'Error al registrar el proveedor. Contáctese con el administrador del Sistema.' });
                    }
                } else {
                    setMsg({ show: true, msg: 'Existen problemas en la red. Contáctese con el administrador del Sistema.' });
                }
                setOpenLoader(false);
            }
        );
    }

    const { errors, handleSubmit, getObject } = useForm(handleSave, validations.addProvider, existError);

    function closeAlert() { setMsg({ show: false }); }


    const handleClickOpen = () => {
        setOpen(true);
        setClient({
            rucEmpresa: userToken ? getRUCEmpresa(userToken) : "0",
            parteRelacionada: false,
        });
        setMsg({ show: false, msg: null, type: null });
        errors.rucCliente = null;
        errors.razonSocial = null;
        errors.correoCliente = null;
        errors.telefonoCliente = null;
        errors.direccionCliente = null;
    };

    const handleClose = () => {
        setOpen(false);
    };



    const handleChangeCheck = event => {
        setClient({
            ...client,
            [event.target.name]: event.target.value === "S" ? true : false,
        });
        getObject({
            ...client,
            typeDocument: event.target.value
        });
    }

    const handleChange = event => {
        setClient({
            ...client,
            [event.target.name]: event.target.value
        });
        getObject({
            ...client,
            [event.target.name]: event.target.value,
            typeDocument: pasaporteCheck
        });
    }

    return (
        <Fragment>
            <Button variant="contained" color="primary" onClick={handleClickOpen}>
                <PersonAddIcon style={{ color: palette.primary.contrastText, paddingRight: '3%' }} fontSize="small" />  Agregar Proveedor
            </Button>
            <Dialog fullWidth maxWidth="md" open={open} onClose={handleClose}
                disableBackdropClick
                disableEscapeKeyDown
            >
                <DialogTitle id="max-width-dialog-title">Agregar proveedor</DialogTitle>
                <DialogContent>
                    <form onSubmit={event => { setOpenLoader(true); handleSubmit(event); }}>
                        <Grid container direction="row" justify="flex-start" alignItems="center">
                            <Grid item xs={12} md={12}>
                                <label>Los campos marcados con (  <font color={palette.error.main}> *</font> ) son obligatorios:</label>
                            </Grid>
                            {msgError.show ?
                                <Alert
                                    tipo={msgError.type}
                                    mensaje={msgError.msg}
                                    mesajeSubrayado={null}
                                    titulo={null}
                                    mostrar={msgError.show}
                                    cerrarAlerta={closeAlert}
                                /> : null
                            }
                            <Grid item xs={12} md={3} className={classes.divForm}>
                                <label>Identificación: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid item xs={12} md={3} className={classes.divInput}>
                                <input type="text" className={errors.rucCliente ? 'form-control is-invalid' : 'form-control'}
                                    placeholder="Ej. 1737199872"
                                    name="rucCliente"
                                    value={client.rucCliente}
                                    onChange={handleChange}
                                    autoComplete="off"
                                />
                                {errors.rucCliente ?
                                    <p className={classesApp.errorLetters}>{errors.rucCliente}</p>
                                    :
                                    null
                                }
                            </Grid>

                            <Grid item xs={12} md={1} className={classes.divForm}>
                                <label>Nombre: <font color={palette.error.main}>*</font></label>
                            </Grid>
                            <Grid item xs={12} md={5} className={classes.divInput}>
                                <input type="text" className={errors.razonSocial ? 'form-control is-invalid' : 'form-control'}
                                    placeholder="Ej. Juan Mauricio Pérez Calle"
                                    name="razonSocial"
                                    value={client.razonSocial}
                                    onChange={handleChange}
                                    autoComplete="off" />
                                {errors.razonSocial ?
                                    <p className={classesApp.errorLetters}>{errors.razonSocial}</p>
                                    :
                                    null
                                }
                            </Grid>

                            <Grid item xs={12} md={3} className={classes.divlabel}>
                                Tipo: <font color={palette.error.main}> *</font>
                            </Grid>
                            <Grid item md={3} xs={12} className={classes.divInput}>
                                <select
                                    name="tipo"
                                    className={
                                        errors.tipo
                                            ? "form-control is-invalid"
                                            : "form-control"
                                    }
                                    value={client.tipo}
                                    onChange={handleChange}
                                >
                                    <option value="">--Seleccione--</option>
                                    <option value="01">Persona natural</option>
                                    <option value="02">Sociedad</option>
                                </select>
                                {errors.tipo ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.tipo}
                                    </p>
                                ) : null}
                            </Grid>

                            <Grid item xs={12} md={3} >
                                Parte relacionada: <font color={palette.error.main}>*</font>
                            </Grid>
                            <Grid item xs={12} md={3}   >
                                <FormControl component="fieldset" className={classes.formControl}>
                                    <RadioGroup
                                        name="parteRelacionada"
                                        className={classes.radio}
                                        value={client.parteRelacionada ? "S" : "N"}
                                        onChange={handleChangeCheck}
                                    >
                                        <FormControlLabel
                                            value="S"
                                            control={<Radio color="primary" className={classes.radioButton} />}
                                            label="Si"
                                            labelPlacement="start"
                                            className={classes.radioLable}
                                        />
                                        <FormControlLabel
                                            value="N"
                                            control={<Radio color="primary" className={classes.radioButton} />}
                                            label="No"
                                            labelPlacement="start"
                                            className={classes.radioLable}
                                        />
                                    </RadioGroup>
                                </FormControl>
                            </Grid>

                            <Grid container spacing={3} justify='center' >
                                <Grid item md={12} xs={12} >
                                    <Divider></Divider>
                                </Grid>
                                <Button variant="contained" color="primary" type="submit" className={classesGlobal.marginButton} >
                                    Agregar
                                </Button>
                                <Button variant="outlined" color="secondary" onClick={handleClose} className={classesGlobal.marginButton} >
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
            </Dialog>
            <Backdrop className={classes.backdrop} open={openLoader} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </Fragment>
    );
}

export default AddClientBtn;